var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.seat)?_c('div',[_c('img',{staticClass:"seat-drawing",attrs:{"src":_vm.drawing}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }